import React, { useEffect, useState, Fragment } from 'react';

//*MUI
import { Box, Divider } from '@mui/material';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from './TokenRefund.module.css';
import ThreeDotsMenu from '../../../Subcomponents/ThreeDotsMenu';
import Datagrid from '../../../Subcomponents/Datagrid';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import {
  getAllEventsTokenRefundRequests,
  getEventByEventName,
  updateRefundToken,
} from '../../../Services/Event';
import SiteVisitIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import { useParams } from 'react-router-dom';
import { debounce, sortBy } from 'lodash';
import { errorTost, successTost } from '../../../Services/Toast';
import LeadStatusChip from '../../../Subcomponents/LeadStatusChip';
import Dot from '../../Icons/Dot';
import { addLeadLogs, updateLeadAllStatus } from '../../../Services/Lead';
import {
  getLinkedTokenDetails,
  updateEventLeadToken,
  updateEventLeadTokenGroup,
  updateLeadTokenStatus,
} from '../../../Services/AssignNewToken';
import { refundTokenPayment } from '../../../Services/PaymentApi';
import { dismissLoader, presentLoader } from '../../../Services/loader';

function TokenRefund() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const [NoTokenRefundRequests, setNoTokenRefundRequests] = useState(null);
  const [refundTokenArr, setRefundTokenArr] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [queryPage, setQueryPage] = useState(0);
  const [listsOrder, setListsOrder] = useState([
    'Name Ascending',
    'Name Descending',
    'Oldest First',
    'Latest First',
  ]);
  const [filterBy, setFilterBy] = useState('Latest First');
  const [search, setSearch] = useState('');
  const [TotalCount, setTotalCount] = useState(0);
  const [EventName, setEventName] = useState('');
  const { eventID } = useParams();
  useEffect(() => {
    dispatch(action.activeMenu('tokenrefundrequests'));
    getAllTokenRefundRequests(false, search, filterBy);
  }, []);




  const refundRequestColumns = [
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => {
        return (
          <ThreeDotsMenu
            list={params.row.subMenuList}
            selectedValue={(e) => {
              if (e === 'Approve') {
                //??Refund Api call then update Lead status after success of refund token which will from siddharth side
                // !!Adding Refund Token api
                let body = {
                  mode: 'Token',
                  paymentId: params.row?.paymentId?.paymentId,
                };
                presentLoader();
                refundTokenPayment(body)
                  .then((respRefundTokenPay) => {
                    console.log({ respRefundTokenPay });
                    if (
                      respRefundTokenPay?.data?.success[0]?.status === 'success'
                    ) {
                      updateRefundToken(
                        params.row.tokenRefundRequestId,
                        'approved'
                      )
                        .then((resp) => {
                          // ??New Update for priority pass if upgraded token token is active or upgraded unlinking token from priority pass
                          if (params.row.upgradedToken) {
                            let eventTokenObj = {
                              // ??added this condition because what if token is already in refund request stage
                              status: params.row.upgradedToken?.status === 'active' ? 'active' : params.row.upgradedToken?.status,
                              isPrerequisiteUsed: false,
                              linkedTokenId: null
                            }
                            updateEventLeadTokenGroup(eventTokenObj, params.row.upgradedToken.paymentId).then((response) => {
                              console.log('update eventTokenLeadRelation ugraded token', response)
                            }).catch((error) => {
                              console.log(error);
                            });
                          }
                          // !Condition added if token is linked should we removed this??
                          // ??based on discussion don't removed linked we'll think something different to show refund request
                          // if(params.row.paymentId.linkedTokenId){
                          //   let eventTokenObj={
                          //     // ??added this condition because what if token is already in refund request stage
                          //     isPrerequisiteUsed:false,
                          //     linkedTokenId:null
                          //   }
                          //   updateEventLeadTokenGroup(eventTokenObj,params.row.paymentId.paymentId).then((response)=>{
                          //     console.log('update eventTokenLeadRelation ugraded token',response)
                          //   }).catch((error)=>{
                          //     console.log(error);
                          //   });
                          // }
                          // !!All Updates are Handled by Siddarth's refundtokenpayment api
                          updateLeadAllStatus(
                            params.row?.paymentId?.leadId?.leadId,
                            'Token Refunded'
                          )
                            .then((updateLeadStatus) => {
                              console.log(updateLeadStatus);
                              let obj = {
                                leadId: params.row?.paymentId?.leadId?.leadId,
                                leadStatus: `Token Refunded`,
                                message: `Token Refund initiated by ${loggedInUser.name}(${loggedInUser?.roleId?.title})`,
                              };
                              addLeadLogs(obj)
                                .then((leadLog) => {
                                  console.log(leadLog);
                                })
                                .catch((err) => {
                                  console.log('leadlog', err);
                                });
                            })
                            .catch((err) => {
                              console.log('err while rejecting token refund');
                            });
                          dismissLoader();
                          setSearch('');
                          document.getElementById(
                            'input-with-icon-textfield refundRequestLeads'
                          ).value = '';
                          getAllTokenRefundRequests(false, '', filterBy);
                          successTost('Token refund initiated successfully');
                        })
                        .catch((err) => {
                          dismissLoader();
                          console.log(err);
                        });
                    } else {
                      dismissLoader();
                      errorTost(respRefundTokenPay?.data?.failed[0]?.reason);
                    }
                  })
                  .catch((errInRefundPay) => {
                    dismissLoader();
                    console.log({ errInRefundPay });
                    errorTost(errInRefundPay.message);
                  });
              } else if (e === 'Reject') {
                // ??Update Status
                presentLoader();
                updateRefundToken(params.row.tokenRefundRequestId, 'rejected')
                  .then((resp) => {
                    successTost('Token has been rejected successfully');
                    updateLeadAllStatus(
                      params.row?.paymentId?.leadId?.leadId,
                      'Token Refund Request Rejected'
                    )
                      .then((updateLeadStatus) => {
                        console.log(updateLeadStatus);
                        let obj = {
                          leadId: params.row?.paymentId?.leadId?.leadId,
                          leadStatus: `Token Refund Request Rejected`,
                          message: `Token Refund rejected by ${loggedInUser.name}(${loggedInUser?.roleId?.title}`,
                        };
                        addLeadLogs(obj)
                          .then((leadLog) => {
                            console.log(leadLog);
                          })
                          .catch((err) => {
                            console.log('leadlog', err);
                          });
                        updateLeadTokenStatus(
                          params.row?.paymentId?.leadId?.leadId,
                          'active',
                          params.row?.paymentId?.paymentId
                        )
                          .then((resp) => {
                            console.log(resp);
                          })
                          .catch((errResp) => {
                            console.log(
                              errResp,
                              'err while updating eventTokenLeadRelation'
                            );
                          });
                        dismissLoader();
                        setSearch('');
                        document.getElementById(
                          'input-with-icon-textfield refundRequestLeads'
                        ).value = '';
                        getAllTokenRefundRequests(false, '', filterBy);
                      })
                      .catch((err) => {
                        console.log('err while rejecting token refund');
                      });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }}
          />
        );
      },
    },
    {
      field: 'leadName',
      headerName: 'Lead Name',
      width: 280,
      renderCell: (params) => {
        return (
          <div>
            <div>{params.row.leadName}</div>
            <div>{params.row.leadId}</div>
          </div>
        );
      },
    },
    {
      field: 'tokenNumber',
      headerName: 'Token Number',
      width: 300,
    },
    {
      field: 'status',
      headerName: 'Refund Status',
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {(params.row.status === 'pending' ||
              params.row.status === 'Pending') && (
                <LeadStatusChip
                  style={{ color: '#B54708', backgroundColor: '#FFFAEB' }}
                  label={params.row.status}
                  icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
                />
              )}
            {params.row.status === 'approved' && (
              <LeadStatusChip
                style={{ color: '#027A48', backgroundColor: '#ECFDF3' }}
                label={params.row.status}
                icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
              />
            )}
            {params.row.status === 'rejected' && (
              <LeadStatusChip
                style={{ color: '#B42318', backgroundColor: '#FEF3F2' }}
                label={params.row.status}
                icon={<Dot width={'0.5rem'} height={'0.5rem'} />}
              />
            )}
          </div>
        );
      },
    },
    {
      field: 'requestRaisedBy',
      headerName: 'Request Raised By',
      width: 250,
    },
    {
      field: 'amountPaid',
      headerName: 'Amount Paid',
      width: 250,
      renderCell: (params) => {
        return <div>₹{params.row.amountPaid}</div>;
      },
    },
    {
      field: 'reason',
      headerName: 'Reason',
      width: 300,
      renderCell: (params) => {
        return <div style={{
          overflow: "hidden",
          whiteSpace: "break-spaces",
        }}>{params.row.reason}</div>;
      },
    },
  ];
  useEffect(() => {
    console.log({ eventID }, useParams);
    getEventName();
  }, []);
  useEffect(() => {
    if (queryPage > 0) {
      getAllTokenRefundRequests(true, search, filterBy);
    }
  }, [queryPage]);

  function getEventName() {
    getEventByEventName(eventID).then((response) => {
      console.log('Event-Name', response[0].title);
      setEventName(response[0].title);
    });
  }

  function getAllTokenRefundRequests(merge, search, filterBy) {
    getAllEventsTokenRefundRequests(
      eventID,
      queryPage,
      filterBy,
      search,
      loggedInUser.userId
    ).then((resRefundTokens) => {
      console.log('events-token-refund-requests', resRefundTokens);

      // if (resRefundTokens.count > 0) {
      //   setNoTokenRefundRequests(true);
      // &&el.userId!==null
      resRefundTokens = resRefundTokens.data.filter((el) => {
        return (
          el.paymentId !== null && el?.paymentId?.leadId?.personId !== null
        );
      });
      resRefundTokens = resRefundTokens.map((each) => ({
        ...each,
        id: each?.tokenRefundRequestId,
        leadName: each?.paymentId?.leadId?.personId?.name,
        leadId:
          'VJ' +
          each?.paymentId?.leadId?.leadDisplayId?.replace(
            each?.paymentId?.leadId?.leadDisplayId?.substring(8, 12),
            '-' + each?.paymentId?.leadId?.leadDisplayId?.substring(8, 12)
          ),
        tokenNumber: each?.paymentId?.tokenNumber,
        requestRaisedBy: each?.userId?.name,
        tokenStatus: each?.paymentId?.status,
        amountPaid: each?.paymentId?.paidAmount,
        subMenuList: [],
      }));
      if (filterBy.includes('Name')) {
        if (filterBy.includes('Ascending')) {
          resRefundTokens = sortBy(resRefundTokens, 'leadName');
        } else {
          resRefundTokens = sortBy(resRefundTokens, 'leadName').reverse();
        }
      }
      if (filterBy.includes('Latest')) {
        if (filterBy.includes('Ascending')) {
          resRefundTokens = sortBy(resRefundTokens, 'last_updated_at');
        } else {
          resRefundTokens = sortBy(
            resRefundTokens,
            'last_updated_at'
          ).reverse();
        }
      }
      resRefundTokens.forEach((el) => {
        if (el.status === 'approved') {
          // el.subMenuList.push('Reject');
          el.subMenuList.push('No Actions Available');
        } else if (el.status === 'rejected') {
          // el.subMenuList.push('Approve');
          el.subMenuList.push('No Actions Available');
        } else {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Event?.['View Details']?.[
              'Token Refund Requests'
            ]?.Accept?.isAccessible &&
            loggedInUser?.roleId?.accessibleTabs?.Event?.['View Details']?.[
              'Token Refund Requests'
            ]?.Reject?.isAccessible
          ) {
            el.subMenuList.push('Approve');
            el.subMenuList.push('Reject');
          } else if (
            loggedInUser?.roleId?.accessibleTabs?.Event?.['View Details']?.[
              'Token Refund Requests'
            ]?.Accept?.isAccessible
          ) {
            el.subMenuList.push('Approve');
          } else if (
            loggedInUser?.roleId?.accessibleTabs?.Event?.['View Details']?.[
              'Token Refund Requests'
            ]?.Reject?.isAccessible
          ) {
            el.subMenuList.push('Reject');
          }
        }
        // ??New update for prioirty pass token unlinked the upgraded token when approved
        getLinkedTokenDetails(el?.paymentId?.eventId, el?.paymentId?.paymentId, el?.paymentId?.leadId?.leadId).then((response) => {

          el.upgradedToken = response[0];
        }).catch((err) => {
          console.log('error while getting event',)
        })
      });
      console.log('events-token-refund-requestsAfterFilter', resRefundTokens);
      setTotalCount(resRefundTokens.length);
      if (resRefundTokens.length) {
        setNoTokenRefundRequests(true);
      } else {
        setNoTokenRefundRequests(false);
      }
      setRefundTokenArr([...resRefundTokens]);
      if (!merge) {
        setRefundTokenArr([...resRefundTokens]);
      } else {
        setRefundTokenArr((pre) => {
          return [...pre, ...resRefundTokens];
        });
      }
      // } else {
      //   setNoTokenRefundRequests(false);
      // }
    }).catch((err) => {
      console.error("getAllEventsTokenRefundRequests", err)
    });
  }

  function pageChanged(e) {
    setCurrentPage(e);
    if (queryPage < e) {
      setQueryPage(e);
    }
  }
  const filterBySort = (e) => {
    console.log(e);
    setFilterBy(e);
    getAllTokenRefundRequests(false, search, e);
  };
  const debouncedFetchSearchData = debounce((e) => {
    let searchData = e.target.value;
    setSearch(searchData);
    getAllTokenRefundRequests(false, searchData, filterBy);
  }, 800);

  return (
    <Box className={cssClasses.Container}>
      <Box mb={2}>
        <Box className={cssClasses.HeaderTitle}>{EventName}</Box>
      </Box>

      <Divider />


      <Fragment>
        <Box margin={'1.3rem 0'}>
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.SubHeaderTitle} mt={3.5}>
              {TotalCount} Token Refund Requests
            </Box>
            <Box className={cssClasses.flexCol}>
              <Box className={cssClasses.SubTitle} marginLeft={'2rem'}>
                Sort by
              </Box>
              <Box width={'250px'} margin={'0 2rem'}>
                <DropDown
                  list={listsOrder}
                  style={{
                    selectedColor: '#175CD3', background: '#E8F0FE'
                  }}
                  onChangeSelect={(e) => {
                    filterBySort(e);
                  }}
                  selectedValue={filterBy}
                />
              </Box>
            </Box>

            <Box marginLeft={'auto'} marginTop={'2.2rem'}>
              <SearchBar
                placeholder={'Search by lead name'}
                search={debouncedFetchSearchData}
                id={'refundRequestLeads'}
              />
            </Box>
          </Box>
        </Box>

        {NoTokenRefundRequests === true && (
          <Box className={cssClasses.GridWrapper}>
            <Datagrid
              rows={refundTokenArr}
              columns={refundRequestColumns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              page={currentPage}
              onPageChange={(e) => {
                pageChanged(e);
              }}
              hideFooter={false}
            />
          </Box>
        )}
      </Fragment>


      {NoTokenRefundRequests === false && (
        <Box>
          <Box width={'100%'} height={'100%'}>
            <Box className={cssClasses.noDataMsg}>
              <Box className={cssClasses.emptyIcon}>
                <img src={SiteVisitIcon} alt='No Token Refund Requests  Yet' />
              </Box>
              <Box className={cssClasses.emptyTitle}>
                No Token Refund Requests were found
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default TokenRefund;
